import createDuck from '../../lib/ducks/remoteDuck'
import Carrier from '../../lib/api/carrier'

export default createDuck({
  namespace: 'account',
  store: 'carrier',
  fetchCallback: (option) => Carrier.get(option),
})
